<section
  fxLayout="column"
  fxLayoutAlign=""
  class="page-container default-padding"
>
  <h3>
    {{ "GTAP" }} |
    <span class="mat-title">Resumes</span>
  </h3>
  <mat-divider></mat-divider>
</section>
